import React from 'react';
import ReactDOM from 'react-dom';
import Root from './Components/Root';
import registerServiceWorker from './registerServiceWorker';
// Redux store
import {createStore, compose, applyMiddleware} from 'redux';
import * as asyncInitialState from 'redux-async-initial-state';
import {appState} from './Reducer/reducer';
import {STORE_NAME, db} from './firebase';


const loadStore = (currentState) => {
    return new Promise(resolve => {
        db.then(dbResource =>{
            return dbResource.transaction(STORE_NAME)
                    .objectStore(STORE_NAME).get("1");
        }).then(data =>{
            resolve({
                ...currentState,
                currentQuote: data
            })
        });
    });
}

const store = createStore(
    appState, 
    compose(  applyMiddleware( asyncInitialState.middleware(loadStore) )  )
);
ReactDOM.render(
    <Root store={store} />, document.getElementById('root'));
registerServiceWorker();


 


// WEBPACK FOOTER //
// ./src/index.js